function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Error App component
 * 
 * This component shows on the Details page if there is no Application ID in the store
 * It also shows if the user cancels their application, so we load a spinner in this case.
 * 
 * We use a time to show the component, and dispatch and error to Bugsnag
 *  
 * 
 */
import * as React from 'react';
import Loading from '../loading/Loading';
import { Redirect } from 'react-router-dom';
import './ErrorApp.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorApp extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "timeoutID", void 0);
    _defineProperty(this, "timer", () => setTimeout(this.error, 1000));
    _defineProperty(this, "error", () => {
      this.setState({
        show: true
      });
    });
    this.state = {
      show: false
    };
    this.timeoutID = this.timer();
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }
  render() {
    if (!this.state.show) {
      return /*#__PURE__*/_jsx(Loading, {});
    }
    return /*#__PURE__*/_jsx(Redirect, {
      to: "/"
    });
  }
}
export default ErrorApp;